import api from '../../../api';
import { ResponseSuccess } from '../../../shared/types';
import {
  ReactivateResumeSubscriptionRequestPayload,
  SubscriptionCustomerPortalSessionRequestPayload,
  SubscriptionPreviewRequestPayload,
  SubscriptionUpgradeRequestPayload,
  ValidateCouponCodeRequestPayload,
} from './types';

export const getSubscription = () => api.get<ResponseSuccess>('/subscription');

export const getPlans = async () => api.get<ResponseSuccess>('/plans');

export const getSubscriptionPreview = async (
  params: SubscriptionPreviewRequestPayload,
) => api.get<ResponseSuccess>('/subscription/preview', { params });

export const subscriptionUpdateStatus = async (priceId: string) =>
  api.patch<ResponseSuccess>(
    '/subscription/update-account-subscription-status',
    {
      priceId,
    },
  );

export const subscriptionUpgrade = async (
  payload: SubscriptionUpgradeRequestPayload,
) => api.post<ResponseSuccess>('/subscription/upgrade', payload);

export const subscriptionCustomerPortalSession = async (
  payload: SubscriptionCustomerPortalSessionRequestPayload,
) =>
  api.post<ResponseSuccess>('/subscription/customer-portal-session', payload);

export const subscriptionUpdatePaymentMethod = async () =>
  api.get<ResponseSuccess>(`/subscription/update-payment-method/`);

export const reactivateSubscription = (
  payload: ReactivateResumeSubscriptionRequestPayload,
) => api.post<ResponseSuccess>('/subscription/reactivate', payload);

export const resumeSubscription = () =>
  api.patch<ResponseSuccess>('/subscription/resume');

export const validateCouponCode = async (
  params: ValidateCouponCodeRequestPayload,
) => api.get<ResponseSuccess>('/subscription/coupon/validate', { params });

export const revokePausedSubscription = async () =>
  api.patch<ResponseSuccess>('/subscription/revoke-scheduled-pause');

export const getAccountSettings = async () =>
  api.get<ResponseSuccess>('/accounts');
